module.exports = __webpack_public_path__ + "static/media/open-interop-white.a0204326.svg";